import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import confirm from "webmodals/confirm";
import labels from "servicestack/app-releases/_labels";

export default class AppReleaseContainerController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.labels = labels;
    return {
      url: "QueryAppReleases.json",
      hideLeftNav: $ctrl.$pageConfig.is("lt-md"),
      orderBy: "-Version,-BuiltAt",
      filters: [
        { groupBy: labels.branch },
        { groupBy: labels.version },
        { date: "BuiltAt", title: labels.builtAt },
      ],
      sortOptions: {
        "Version,-BuiltAt": labels.version,
        "-Version,-BuiltAt": labels.version,
      },
      autoLoad: false,
      pageSize: 12,
    };
  }

  $onInit() {
    super.$onInit && super.$onInit();
    const $ctrl = this;
    console.debug("AppReleaseContainerController", $ctrl);
    $ctrl.bus.read("BuildInfo.json").then(({ data }) => {
      $ctrl.buildInfo = data;
      $ctrl.query.criteria.ClientIn = [data.EmunClient.toLowerCase()];
      // $ctrl.query.criteria.BranchIn = [data.GitBranch.toLowerCase()];
      $ctrl.query.criteria.UIIn = [data.EmunUI.toLowerCase()];
      $ctrl.query.load(true);
    });
  }

  install(ar) {
    const $ctrl = this;
    console.debug("install", ar);
    return (
      confirm(
        `
        Do you want to install 
        <br/>
        <strong>${ar.key}</strong> 
        <br/>
        on top of
        <br/>
        <strong>${$ctrl.buildInfo.InformationalVersion}</strong>?`,
        "Are you sure?!?!?!?!"
      )
        .result.then(() => {
          $ctrl.$notify.info("The app is being updated and restarted...", {
            ttl: 8000,
          });
          return $ctrl.bus.send("ApplyRelease.json", ar);
        })
        // .then(() => $ctrl.bus.send("ResetAppPool.json"))
        .then(() => {
          $ctrl.$onInit();
          $ctrl.$notify.success("The app has been restarted...", {
            ttl: 3000,
          });
        })
    );
  }
}
